<template>
  <div>
    <v-dialog max-width="400" v-model="dialog">
      <v-card>
        <v-card-title class="text-h6 lighten-2">
          Unarchive recording
          <v-spacer></v-spacer>
          <v-icon @click="closeDialog" size="18" class="white--black">
            mdi-close
          </v-icon>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-6 text-center"
          >Are you sure you want to unarchive this recording
          <b>{{ recording_item.title }}</b> ?
        </v-card-text>
        <v-card-actions class="pb-10 pt-5">
          <v-spacer></v-spacer>
          <v-btn
            @click="closeDialog"
            class="grey--text capitalize px-10"
            rounded
            text
          >
            Close
          </v-btn>
          <v-btn
            @click="handleArchive(recording_item)"
            class="capitalize px-10"
            color="primary"
            rounded
            :loading="loading"
          >
            Unarchive recording
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "UnarchiveRecordingDialog",
  props: {
    type: String,
    default: null,
  },
  data() {
    return {
      dialog: false,
      loading: false,
      recording_item: {},
    };
  },
  methods: {
    ...mapActions("recordings", ["unarchive_recording"]),

    async handleArchive(record) {
      this.loading = true;
      try {
        const response = await this.unarchive_recording(record);
        this.$emit("load-recordings");
        window.location.reload();
        this.$parent.toast.sendSuccess(response);
        this.closeDialog();
        this.loading = false;
      } catch (e) {
        this.loading = false;
        this.$parent.toast.sendError(e);
      }
    },
    openDialog(record) {
      this.recording_item = Object.assign({}, record);
      this.dialog = true;
    },
    closeDialog() {
      this.dialog = false;
    },
  },
};
</script>

<style scoped></style>
